import React from "react";
import MainSection from "../Components/MainSection";

function PrivacyPolicy() {
  return (
    <>
      <div className="terms_pg">
        <MainSection
          title="Effective Date: October 10, 2025"
          subtitle="Privacy Policy"
        />
      </div>
      <section className="terms_sec">
        <div className="contair ">
          <h2>Welcome to Girips Technologies</h2>
          <p>
            At Girips Technologies, we respect your privacy and are committed to
            protecting the personal information you share with us. This Privacy
            Policy explains how we collect, use, store, and safeguard your
            information when you interact with our website, products, or
            services.
          </p>
          <div className="terms_inr">
            <h3>1. Introduction</h3>
            <p>
              Girips Technologies (“we”, “our”, “us”) operates{" "}
              <a
                href="https://www.giripstechnologies.com"
                target={"_blank"}
                style={{ color: "rgba(52, 152, 219, 1)" }}
              >
                www.giripstechnologies.com
              </a>{" "}
              and provides technology solutions and IT services (the
              “Services”). We value your privacy and are committed to protecting
              your personal data. This Privacy Policy explains how we collect,
              use, store, and disclose personal information when you:
            </p>
            <ul>
              <li>Visit our Website</li>
              <li>Use or request our Services</li>
              <li>Interact with us (e.g. inquiries, proposals)</li>
            </ul>
            <p>
              By using our Website or Services, you consent to the practices
              described in this policy.
            </p>
            <h3>2. Information We Collect</h3>
            <p>
              <strong>2.1 Personal Information</strong>
            </p>
            <p>
              We may collect personal data when you: fill out contact forms,
              request a quote, subscribe to updates, or communicate with us.
              This includes:
            </p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Company / Organization name</li>
              <li>Project details / requirements</li>
              <li>Billing information (via payment gateways)</li>
            </ul>
            <p>
              <strong>2.2 Technical / Non-personal Data</strong>
            </p>
            <p>
              When you access our Website, we may automatically collect certain
              technical information, such as:
            </p>
            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system and device information</li>
              <li>Pages visited, time & date of access</li>
              <li>Referring URLs</li>
              <li>Analytics data (via tools such as Google Analytics)</li>
            </ul>
            <p>
              <strong>2.3 Cookies & Tracking Technologies</strong>
            </p>
            <p>We use cookies and similar tracking technologies to:</p>
            <ul>
              <li>Maintain user sessions</li>
              <li>Remember preferences</li>
              <li>Analyze website usage and performance</li>
              <li>Improve user experience</li>
            </ul>
            <p>
              You can disable cookies from your browser settings. However,
              disabling cookies may affect some functionality of the Website.
            </p>
            <h3>3. Use of Your Information</h3>
            <p>
              We use the information we collect for purposes including, but not
              limited to:
            </p>
            <ul>
              <li>Responding to your inquiries and communications</li>
              <li>Preparing project proposals, contracts, and documentation</li>
              <li>Managing client accounts and billing</li>
              <li>Processing payments via third-party payment gateways</li>
              <li>Enhancing our Website functionality and user experience</li>
              <li>
                Conducting analytics to understand how our Website and Services
                are used
              </li>
              <li>
                Sending service-related updates or marketing communications
                (only if you opt in)
              </li>
              <li>Complying with legal or regulatory obligations</li>
            </ul>
            <p>
              We do not sell or trade your personal data for marketing purposes.
            </p>
            <h3>4. Data Storage & Security</h3>
            <p>
              We take reasonable technical and organizational measures to
              protect your personal data, including:
            </p>
            <ul>
              <li>SSL encryption for data in transit</li>
              <li>Firewalls and secure server infrastructure</li>
              <li>Access controls and restricted internal access</li>
              <li>Regular security audits / vulnerability scanning</li>
            </ul>
            <p>
              However, no method of data transmission or electronic storage is
              100% secure — we cannot guarantee absolute security.
            </p>
            <h3>5. Payment Information</h3>
            <p>
              All payments are processed through secure third-party payment
              gateways (e.g., PayPal, UPI). We do not store full credit or debit
              card details on our servers.
            </p>
            <h3>6. Sharing Your Data</h3>
            <p>We may share your data with:</p>
            <ul>
              <li>
                Service providers (e.g., hosting, analytics, cloud services) who
                help us operate the Website and deliver Services
              </li>
              <li>
                Third parties when required by law, or to protect our rights
                (e.g., to comply with a legal request)
              </li>
            </ul>
            <p>
              All third-party service providers are contractually obligated to
              keep your data confidential and use it only for the purpose we
              share it.
            </p>
            <h3>7. Data Retention</h3>
            <p>
              We retain personal information only for as long as is necessary
              to:
            </p>
            <ul>
              <li>Fulfill the purposes for which it was collected</li>
              <li>
                Comply with legal, tax, accounting, or regulatory obligations
              </li>
              <li>Maintain historical records of client engagements</li>
            </ul>
            <p>
              Once the information is no longer needed, we securely delete or
              anonymize it.
            </p>
            <h3>8. Your Rights</h3>
            <p>
              Depending on where you are located, you may have rights with
              respect to your data, such as:
            </p>
            <ul>
              <li>Access: Ask for a copy of your personal data</li>
              <li>
                Rectification: Request correction of inaccurate or incomplete
                data
              </li>
              <li>
                Deletion: Ask us to delete your personal data in certain cases
              </li>
              <li>
                Withdraw Consent: Withdraw consent for marketing communications
              </li>
              <li>
                Opt-out of Cookies: Disable non-essential cookies via browser
                settings
              </li>
            </ul>
            <p>
              To exercise your rights, you can contact us at{" "}
              <a
                href="mailto:info@giripstechnologies.com"
                target={"_blank"}
                style={{ color: "rgba(52, 152, 219, 1)" }}
              >
                info@giripstechnologies.com.
              </a>
            </p>

            <h3>9. Children’s Privacy</h3>
            <p>
              Our Website and Services are not directed at individuals under the
              age of 18. We do not knowingly collect personal data from minors.
              If you believe we have collected data from a child, please contact
              us so we can take appropriate action.
            </p>
            <h3>10. International Data Transfers</h3>
            <p>
              Some of our service providers may store or process data outside
              India (for example, via cloud providers). When transferring data
              internationally, we ensure adequate safeguards are in place to
              protect your information.
            </p>
            <h3>11. External Links</h3>
            <p>
              Our website may contain links to third-party websites or services.
              We are not responsible for their privacy practices. Please review
              the privacy policies of those external sites before providing your
              personal data.
            </p>
            <h3>12. Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy periodically to reflect changes
              in our practices, technology, or legal requirements. When we make
              changes, we will:
            </p>
            <ul>
              <li>Post the updated policy on this page</li>
              <li>Update the “Effective Date” at the top</li>
            </ul>
            <p>We encourage you to revisit this Privacy Policy regularly.</p>
            <h3>Girips Technologies</h3>
            <p>
              A7 Virat Nagar, Goner Road, Jaipur, Rajasthan – 302031, India
              <br /> Call Us:
              <a
                href="tel:+91 73574 94050"
                target={"_blank"}
                style={{ color: "rgba(52, 152, 219, 1)" }}
              >
                {" "}
                +91 73574 94050
              </a>
              <br />
              Email Us:{" "}
              <a
                href="mailto:info@giripstechnologies.com"
                target={"_blank"}
                style={{ color: "rgba(52, 152, 219, 1)" }}
              >
                info@giripstechnologies.com
              </a>
            </p>
            <h3>Policy Summary</h3>
            <p>
              Girips Technologies is committed to safeguarding your data. We
              collect only what’s necessary, use it responsibly, secure it
              diligently, and never misuse or sell it. Your trust is our top
              priority.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
